var WizardModel = BaseObjectModel.extend({
  init: function (data) {
    this._super(data);
  },
  className: "WizardModel"
});